import React from "react";
import "./DeezerForArtists.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const DeezerForArtists = () => {

  const steps = [
    "Create your FTTunes account",
    "Upload music & artwork",
    "Deliver music to Deezer",
    "Get your artist profile live",
    "Reach global listeners",
    "Track streams & royalties"
  ];

  return (
    <>
      <Helmet>

        <title>
          Get Your Music on Deezer | Deezer Music Distribution | FT Tunes
        </title>

        <meta
          name="description"
          content="Distribute your music to Deezer with FT Tunes. Reach millions of global listeners, grow your fanbase and earn royalties worldwide."
        />

        <meta
          name="keywords"
          content="Deezer music distribution, upload music to Deezer, Deezer for artists India, FT Tunes music distribution, release music worldwide"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="FT Tunes" />

        <meta
          property="og:title"
          content="Get Your Music on Deezer | FT Tunes"
        />

        <meta
          property="og:description"
          content="Upload your songs to Deezer and reach a global audience with FT Tunes music distribution."
        />

        <meta property="og:type" content="website" />

        <meta
          property="og:url"
          content="https://www.fttunes.com/get-your-music-on-deezer"
        />

      </Helmet>

      <div className="deezer-page">

        {/* HERO */}
        <section className="deezer-hero">
          <Container>

            <img className="deezer-logo"
              src="/Images/deezer-logo.png"
              alt="Get Music on Deezer"
            />

            <h1>
              Get Your Music on Deezer
            </h1>

            <p>
              Get your music on Deezer and reach millions of listeners worldwide with professional music distribution. Deezer is one of the fastest-growing music streaming platforms, helping independent artists, labels, and creators expand their global audience. By releasing your songs on Deezer, you can showcase your talent, grow your fanbase, and earn streaming royalties effortlessly. Our music distribution service ensures quick approval, high-quality audio delivery, and complete artist control over your releases. Whether you are launching your first single or promoting a full album, distribute your music on Deezer today and take your music career to the next level with worldwide exposure.
            </p>

            <Button
              className="gradient-btn"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Releasing Music
            </Button>

          </Container>
          <div className="hero-glow-deezer"></div>

        </section>

        {/* SHOWCASE */}
        <section className="deezer-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Reach Global Streaming Audiences</h2>

                <p>
                  Deezer connects artists with listeners across more than 180
                  countries. Upload your music and grow internationally.
                </p>

                <Button
                  className="outline-btn"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Distribute Now
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-your-music-on-deezer.png"
                  alt="get your music on deezer"
                  className="deezer-image"
                />
              </Col>

            </Row>
          </Container>
        </section>

        {/* STEPS */}
        <section className="deezer-steps">
          <Container>

            <h2 className="section-title">
              How It Works
            </h2>

            <Row>
              {steps.map((step,index)=>(
                <Col md={4} key={index}>
                  <div className="step-card">
                    <span>0{index+1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>

        {/* BENEFITS */}
        <section className="deezer-benefits">
          <Container>

            <h2 className="section-title">
              Built For Independent Artists
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Worldwide Reach</h5>
                  <p>Distribute music globally across Deezer users.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>100% Ownership</h5>
                  <p>You keep full rights to your songs.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Streaming Revenue</h5>
                  <p>Earn royalties from every stream.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Artist Growth</h5>
                  <p>Expand your audience internationally.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>

        {/* CTA */}
        <section className="deezer-cta">
          <Container>
            <h2>Start Growing on Deezer Today</h2>

            <Button
              className="gradient-btn big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Upload Your Music
            </Button>
          </Container>
        </section>

      </div>
    </>
  );
};

export default DeezerForArtists;